export enum ReasonTypeEnum {
  Blacklist = 1,
  Part = 2,
  Cancel = 3,
  TransferredSupplier = 4,
  NotQuote = 5,
  ReturnApprovalProcess = 6,
  EditPrice = 6,
  QuoteChangeStatus = 7,
  EditInvoice = 8,
  RequoteProcurement = 9,
  RequoteQuote = 10,
  QuoteManual = 11,
  Reassing = 12,
  DirectAssign = 19,
  ClaimValuationTypeTotalLoss = 21,
  ChangeCompany = 25,
  RejectPart = 27,

  NotReason = 9999

}

